<template>
  <b-container class="pt-5">
    <b-row align-h="center" align-v="center" class="profil-form rounded">
      <b-col class="p-4">
        <h2>Profil</h2>
        <hr />
        <b>Imię:</b> {{ user.given_name }} <br />
        <b>Nazwisko:</b> {{ user.family_name }} <br />
        <b>Email:</b> {{ user.email }} <br />
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Vue from "vue";

export default {
  name: "Profile",
  data() {
    return {
      user: {
        given_name: null,
        family_name: null,
        email: null
      }
    };
  },
  mounted() {
    this.$nextTick(function() {
      var $this = this;
      Vue.CognitoAuth.get_current_user_data().then(function(user_data) {
        if (user_data) {
          $this.user = user_data;
        }
      });
    });
  }
};
</script>
<style>
.profil-form {
  background-color: #f8f9fa !important;
}
</style>
